// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3IUYT","disabled":"FileBtn_disabled__OhD6u","warn":"FileBtn_warn__Udro3","fade":"FileBtn_fade__qEabW"};